import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertDialogComponent } from '../modals/alert-dialog/alert-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(public dialog: MatDialog) { }

  alertDialgoRef: any;


  openAlertDialog(message: string, error: boolean, hasCancel: boolean): void {
     this.alertDialgoRef = this.dialog.open(AlertDialogComponent, {
      data: {
        message,
        error,
        hasCancel
      }
    });
  }


  // afterClosed(): {
  //   this.alertDialgoRef.afterClosed().subscribe(result => {
  //     return result;
  //   });
  // }



}
